import React from "react";
import styled from "styled-components";
import SignUpSvg from "../Common/SignUpSvg";

const FullWidthDiv = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TopBar = styled.div`
  position: fixed;
  padding-left: 112px;
  padding-top: 45px;

  svg {
    height: 38px;
  }
`;
const FullWidthLayout = (props) => {
  return (
    <div>
      <TopBar>
        <SignUpSvg isRoute={true} />
      </TopBar>
      <FullWidthDiv>{props.children}</FullWidthDiv>
    </div>
  );
};

export default FullWidthLayout;
